import { Team } from "../../Contracts/User";
import { create } from "zustand";
import { useRequestStore } from "../BackendStore";
import { persist } from "zustand/middleware";
import { PaymentsPartnerCountry } from "../../Contracts/Common";
import { Currency } from "../../Contracts/Finance";

const getTeamUrl = "/v1/payments/teams";

interface TeamState {
  isLoading: boolean;
  currentTeam?: Team;
  getCurrentTeam: (getAccessTokenSilently: any) => Promise<void>;
  formatCurrency: (amount: number, currency?: Currency) => string;
  getCurrencySymbol: (currency?: Currency) => string;
}

export const useTeamStore = create<TeamState>()(
  persist(
    (set, get) => {
      const { getRequest } = useRequestStore.getState();

      const getCurrentTeam = async (getAccessTokenSilently: any) => {
        set({ isLoading: true });
        try {
          const response = await getRequest<Team>(getAccessTokenSilently, getTeamUrl);
          set({ currentTeam: response, isLoading: false });
        } catch (error) {
          console.error("Error fetching team", error);
          set({ isLoading: false });
        }
      };

      const formatCurrency = (amount: number, currency?: Currency) => {
        const currencyTarget = get().currentTeam?.currency || currency || "USD";
        const locale =
          get().currentTeam?.country === PaymentsPartnerCountry.USA
            ? "en-US"
            : get().currentTeam?.country === PaymentsPartnerCountry.UK
              ? "en-GB"
              : navigator.language;
        return new Intl.NumberFormat(locale, {
          style: "currency",
          currency: currencyTarget
        }).format(amount);
      };

      const getCurrencySymbol = (currency?: Currency) => {
        const currencyTarget = get().currentTeam?.currency || currency || "USD";
        const locale =
          get().currentTeam?.country === PaymentsPartnerCountry.USA
            ? "en-US"
            : get().currentTeam?.country === PaymentsPartnerCountry.UK
              ? "en-GB"
              : navigator.language;
        return new Intl.NumberFormat(locale, {
          style: "currency",
          currency: currencyTarget
        }).formatToParts(0)[0].value;
      };

      return {
        isLoading: false,
        getCurrentTeam,
        formatCurrency,
        getCurrencySymbol
      };
    },
    {
      name: "team-store",
      partialize: state => ({
        currentTeam: state.currentTeam
      })
    }
  )
);
